// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dhp-department-scholarship {
  padding: 24px;
  height: 100%;
  overflow-y: auto;
  background: #ffffff;
}

.dss-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.dss-header-left {
  flex: 1 1;
}

.dss-title {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
  margin: 0 0 8px 0;
}

.dss-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.dss-export-btn {
  background: linear-gradient(135deg, #002FA7, #1e40af);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);
}

.dss-export-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.dss-stats-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 32px;
}

.dss-stat-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.dss-stat-value {
  font-size: 32px;
  font-weight: 700;
  color: #002FA7;
  margin-bottom: 8px;
}

.dss-stat-label {
  font-size: 13px;
  color: #64748b;
}

.dss-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
}

.dss-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.dss-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #002FA7;
  margin-top: 0;
  margin-bottom: 18px;
}

.dss-courses-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.dss-course-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.dss-course-header {
  font-size: 18px;
  font-weight: 700;
  color: #002FA7;
  margin-bottom: 16px;
  text-align: center;
}

.dss-course-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 16px;
}

.dss-course-stat {
  text-align: center;
}

.dss-course-stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
}

.dss-course-stat-label {
  font-size: 10px;
  color: #64748b;
  display: block;
  margin-top: 4px;
}

.dss-course-progress {
  margin-top: 12px;
}

.dss-progress-bar {
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
}

.dss-progress-fill.excellent {
  background: #002FA7;
}

.dss-progress-fill.good-excellent {
  background: #002FA7;
}

.dss-progress-fill.good {
  background: #002FA7;
}

.dss-course-filter {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dss-filter-btn {
  padding: 6px 14px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.dss-filter-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.dss-filter-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.dss-table-container {
  overflow-x: auto;
}

.dss-groups-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dss-groups-table th,
.dss-groups-table td {
  padding: 12px 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.dss-groups-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #002FA7;
}

.dss-group-row {
  cursor: pointer;
  transition: background 0.2s;
}

.dss-group-row:hover {
  background: #f0f7ff;
}

.dss-group-name {
  font-weight: 500;
  color: #002FA7;
}

.dss-cell-excellent {
  color: #10b981;
  font-weight: 600;
}

.dss-cell-good-excellent {
  color: #3b82f6;
  font-weight: 600;
}

.dss-cell-good {
  color: #f59e0b;
  font-weight: 600;
}

.dss-cell-none {
  color: #ef4444;
  font-weight: 600;
}

.dss-coverage-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.dss-loading,
.dss-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
}

.dss-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #002FA7;
  border-radius: 50%;
  animation: dss-spin 1s linear infinite;
  margin-bottom: 16px;
}

.dss-retry-btn {
  margin-top: 16px;
  padding: 8px 20px;
  background: #002FA7;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.dss-loading-small {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.dss-loading-spinner-small {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: dss-spin 1s linear infinite;
  margin-bottom: 12px;
}

.dss-loading-small p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

@keyframes dss-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dss-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: dss-fadeIn 0.2s ease;
}

@keyframes dss-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dss-group-modal {
  background: white;
  border-radius: 24px;
  width: 90%;
  max-width: 700px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: dss-slideUp 0.3s ease;
}

.dss-student-modal {
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: dss-slideUp 0.3s ease;
}

.dss-export-modal {
  background: white;
  border-radius: 24px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: dss-slideUp 0.3s ease;
}

@keyframes dss-slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.dss-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 24px 24px 0 0;
}

.dss-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #002FA7;
}

.dss-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #64748b;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.dss-modal-close:hover {
  background: #e2e8f0;
  color: #002FA7;
}

.dss-modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

.dss-group-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dss-group-info-header {
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  padding: 16px 20px;
  border-radius: 16px;
  border-left: 4px solid #002FA7;
}

.dss-group-info-header h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #002FA7;
}

.dss-group-info-header p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.dss-scholarship-categories {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dss-category-block {
  background: #f8fafc;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.dss-category-block:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.dss-category-title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  font-size: 15px;
}

.dss-category-badge {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dss-category-badge.excellent {
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.dss-category-badge.goodexcellent {
  background: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.dss-category-badge.good {
  background: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.dss-category-badge.none {
  background: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2);
}

.dss-category-count {
  margin-left: auto;
  background: #e2e8f0;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.dss-category-students {
  padding: 12px;
  max-height: 250px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dss-student-item {
  padding: 10px 14px;
  background: white;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #1f2937;
  border: 1px solid #e2e8f0;
}

.dss-student-item:hover {
  background: #f0f7ff;
  border-color: #002FA7;
  transform: translateX(4px);
  color: #002FA7;
}

.dss-empty-category {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  font-style: italic;
}

.dss-student-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dss-student-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f0;
}

.dss-student-field:last-child {
  border-bottom: none;
}

.dss-field-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dss-field-value {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
}

.dss-scholarship-type {
  font-weight: 600;
  padding: 4px 0;
}

.dss-modal-toolbar {
  display: flex;
  gap: 10px;
  padding: 12px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.dss-toolbar-btn {
  padding: 8px 16px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dss-toolbar-btn:hover {
  background: #f0f7ff;
  border-color: #002FA7;
  color: #002FA7;
}

.dss-toolbar-btn.primary {
  background: #002FA7;
  border-color: #002FA7;
  color: white;
}

.dss-toolbar-btn.primary:hover {
  background: #1e40af;
}

.dss-edit-area {
  width: 100%;
  min-height: 500px;
  padding: 16px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  resize: vertical;
  background: #fafbfc;
}

.dss-edit-area:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dss-preview-frame {
  width: 100%;
  height: 60vh;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: white;
}

@media (max-width: 768px) {
  .dss-stats-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .dss-courses-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .dss-section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .dss-groups-table th,
  .dss-groups-table td {
    padding: 8px;
    font-size: 11px;
  }
  
  .dss-group-modal,
  .dss-export-modal {
    width: 95%;
    max-height: 90vh;
  }
  
  .dss-student-modal {
    width: 95%;
  }
  
  .dss-modal-header {
    padding: 16px 20px;
  }
  
  .dss-modal-header h3 {
    font-size: 18px;
  }
  
  .dss-modal-content {
    padding: 16px;
  }
  
  .dss-category-title {
    padding: 10px 16px;
    font-size: 14px;
  }
  
  .dss-student-item {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .dss-modal-toolbar {
    padding: 10px 16px;
    gap: 8px;
  }
  
  .dss-toolbar-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .dss-edit-area {
    min-height: 300px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .dss-category-students {
    max-height: 180px;
  }
  
  .dss-student-item {
    padding: 8px 10px;
  }
  
  .dss-toolbar-btn {
    flex: 1 1;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/DepartmentScholarshipSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":[".dhp-department-scholarship {\n  padding: 24px;\n  height: 100%;\n  overflow-y: auto;\n  background: #ffffff;\n}\n\n.dss-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.dss-header-left {\n  flex: 1;\n}\n\n.dss-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0 0 8px 0;\n}\n\n.dss-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n.dss-export-btn {\n  background: linear-gradient(135deg, #002FA7, #1e40af);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);\n}\n\n.dss-export-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.dss-stats-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-bottom: 32px;\n}\n\n.dss-stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.dss-stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #002FA7;\n  margin-bottom: 8px;\n}\n\n.dss-stat-label {\n  font-size: 13px;\n  color: #64748b;\n}\n\n.dss-section {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 24px;\n  border: 1px solid #e2e8f0;\n}\n\n.dss-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.dss-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #002FA7;\n  margin-top: 0;\n  margin-bottom: 18px;\n}\n\n.dss-courses-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.dss-course-card {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.dss-course-header {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002FA7;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.dss-course-stats {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 16px;\n}\n\n.dss-course-stat {\n  text-align: center;\n}\n\n.dss-course-stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.dss-course-stat-label {\n  font-size: 10px;\n  color: #64748b;\n  display: block;\n  margin-top: 4px;\n}\n\n.dss-course-progress {\n  margin-top: 12px;\n}\n\n.dss-progress-bar {\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n}\n\n.dss-progress-fill.excellent {\n  background: #002FA7;\n}\n\n.dss-progress-fill.good-excellent {\n  background: #002FA7;\n}\n\n.dss-progress-fill.good {\n  background: #002FA7;\n}\n\n.dss-course-filter {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dss-filter-btn {\n  padding: 6px 14px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dss-filter-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.dss-filter-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.dss-table-container {\n  overflow-x: auto;\n}\n\n.dss-groups-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.dss-groups-table th,\n.dss-groups-table td {\n  padding: 12px 12px;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dss-groups-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dss-group-row {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.dss-group-row:hover {\n  background: #f0f7ff;\n}\n\n.dss-group-name {\n  font-weight: 500;\n  color: #002FA7;\n}\n\n.dss-cell-excellent {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.dss-cell-good-excellent {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.dss-cell-good {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.dss-cell-none {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.dss-coverage-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n.dss-loading,\n.dss-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 300px;\n}\n\n.dss-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #002FA7;\n  border-radius: 50%;\n  animation: dss-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.dss-retry-btn {\n  margin-top: 16px;\n  padding: 8px 20px;\n  background: #002FA7;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.dss-loading-small {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  text-align: center;\n}\n\n.dss-loading-spinner-small {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: dss-spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.dss-loading-small p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n@keyframes dss-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.dss-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: dss-fadeIn 0.2s ease;\n}\n\n@keyframes dss-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.dss-group-modal {\n  background: white;\n  border-radius: 24px;\n  width: 90%;\n  max-width: 700px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: dss-slideUp 0.3s ease;\n}\n\n.dss-student-modal {\n  background: white;\n  border-radius: 20px;\n  width: 90%;\n  max-width: 450px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: dss-slideUp 0.3s ease;\n}\n\n.dss-export-modal {\n  background: white;\n  border-radius: 24px;\n  width: 90%;\n  max-width: 1200px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: dss-slideUp 0.3s ease;\n}\n\n@keyframes dss-slideUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.dss-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 24px 24px 0 0;\n}\n\n.dss-modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dss-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #64748b;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.dss-modal-close:hover {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.dss-modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.dss-group-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dss-group-info-header {\n  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);\n  padding: 16px 20px;\n  border-radius: 16px;\n  border-left: 4px solid #002FA7;\n}\n\n.dss-group-info-header h4 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dss-group-info-header p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.dss-scholarship-categories {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dss-category-block {\n  background: #f8fafc;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.dss-category-block:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.dss-category-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.dss-category-badge {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.dss-category-badge.excellent {\n  background: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n}\n\n.dss-category-badge.goodexcellent {\n  background: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n.dss-category-badge.good {\n  background: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.dss-category-badge.none {\n  background: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2);\n}\n\n.dss-category-count {\n  margin-left: auto;\n  background: #e2e8f0;\n  padding: 2px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.dss-category-students {\n  padding: 12px;\n  max-height: 250px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.dss-student-item {\n  padding: 10px 14px;\n  background: white;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #1f2937;\n  border: 1px solid #e2e8f0;\n}\n\n.dss-student-item:hover {\n  background: #f0f7ff;\n  border-color: #002FA7;\n  transform: translateX(4px);\n  color: #002FA7;\n}\n\n.dss-empty-category {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.dss-student-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dss-student-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dss-student-field:last-child {\n  border-bottom: none;\n}\n\n.dss-field-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dss-field-value {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.dss-scholarship-type {\n  font-weight: 600;\n  padding: 4px 0;\n}\n\n.dss-modal-toolbar {\n  display: flex;\n  gap: 10px;\n  padding: 12px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.dss-toolbar-btn {\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dss-toolbar-btn:hover {\n  background: #f0f7ff;\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.dss-toolbar-btn.primary {\n  background: #002FA7;\n  border-color: #002FA7;\n  color: white;\n}\n\n.dss-toolbar-btn.primary:hover {\n  background: #1e40af;\n}\n\n.dss-edit-area {\n  width: 100%;\n  min-height: 500px;\n  padding: 16px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  resize: vertical;\n  background: #fafbfc;\n}\n\n.dss-edit-area:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dss-preview-frame {\n  width: 100%;\n  height: 60vh;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: white;\n}\n\n@media (max-width: 768px) {\n  .dss-stats-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .dss-courses-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .dss-section-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .dss-groups-table th,\n  .dss-groups-table td {\n    padding: 8px;\n    font-size: 11px;\n  }\n  \n  .dss-group-modal,\n  .dss-export-modal {\n    width: 95%;\n    max-height: 90vh;\n  }\n  \n  .dss-student-modal {\n    width: 95%;\n  }\n  \n  .dss-modal-header {\n    padding: 16px 20px;\n  }\n  \n  .dss-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .dss-modal-content {\n    padding: 16px;\n  }\n  \n  .dss-category-title {\n    padding: 10px 16px;\n    font-size: 14px;\n  }\n  \n  .dss-student-item {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n  \n  .dss-modal-toolbar {\n    padding: 10px 16px;\n    gap: 8px;\n  }\n  \n  .dss-toolbar-btn {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n  \n  .dss-edit-area {\n    min-height: 300px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dss-category-students {\n    max-height: 180px;\n  }\n  \n  .dss-student-item {\n    padding: 8px 10px;\n  }\n  \n  .dss-toolbar-btn {\n    flex: 1;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
